/**
 * Favorites Dropdown Functionality
 */
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    initFavoritesDropdown();
  });

  function initFavoritesDropdown() {
    // Create the favorites dropdown container
    createFavoritesDropdown();

    // Add event listeners
    setupEventListeners();

    // Load favorites from localStorage
    loadFavorites();
  }

  function createFavoritesDropdown() {
    // Create dropdown for desktop
    const desktopWishlistAction = document.querySelector('.header-action--wishlist');
    if (desktopWishlistAction) {
      const dropdownHTML = `
        <div class="favorites-dropdown">
          <div class="favorites-dropdown__header">
            <h3>Your Favorites</h3>
          </div>
          <div class="favorites-dropdown__content">
            <div class="favorites-dropdown__empty">
              <p>You have no favorites yet.</p>
            </div>
            <div class="favorites-dropdown__items"></div>
          </div>
          <div class="favorites-dropdown__footer">
            <a href="/pages/favorites" class="favorites-dropdown__view-all">View All Favorites</a>
          </div>
        </div>
      `;
      desktopWishlistAction.insertAdjacentHTML('beforeend', dropdownHTML);
    }

    // Create dropdown for mobile
    const mobileWishlistAction = document.querySelector('.mobile-menu__quick-action[href="/pages/favorites"]');
    if (mobileWishlistAction) {
      const dropdownHTML = `
        <div class="favorites-dropdown favorites-dropdown--mobile">
          <div class="favorites-dropdown__header">
            <h3>Your Favorites</h3>
            <button class="favorites-dropdown__close">×</button>
          </div>
          <div class="favorites-dropdown__content">
            <div class="favorites-dropdown__empty">
              <p>You have no favorites yet.</p>
            </div>
            <div class="favorites-dropdown__items"></div>
          </div>
          <div class="favorites-dropdown__footer">
            <a href="/pages/favorites" class="favorites-dropdown__view-all">View All Favorites</a>
          </div>
        </div>
      `;
      mobileWishlistAction.insertAdjacentHTML('afterend', dropdownHTML);
    }

    // Add styles for the dropdown
    addDropdownStyles();
  }

  function addDropdownStyles() {
    const styleElement = document.createElement('style');
    styleElement.textContent = `
      .favorites-dropdown {
        position: absolute;
        top: 100%;
        right: 0;
        width: 320px;
        background: #fff;
        border-radius: 4px;
        box-shadow: 0 5px 15px rgba(0,0,0,0.1);
        z-index: 100;
        display: none;
        margin-top: 10px;
      }

      .favorites-dropdown.active {
        display: block;
      }

      .favorites-dropdown__header {
        padding: 15px;
        border-bottom: 1px solid #eee;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .favorites-dropdown__header h3 {
        margin: 0;
        font-size: 16px;
        font-weight: 500;
      }

      .favorites-dropdown__close {
        background: none;
        border: none;
        font-size: 20px;
        cursor: pointer;
        padding: 0;
        line-height: 1;
      }

      .favorites-dropdown__content {
        padding: 15px;
        max-height: 300px;
        overflow-y: auto;
      }

      .favorites-dropdown__empty {
        text-align: center;
        padding: 20px 0;
      }

      .favorites-dropdown__item {
        display: flex;
        align-items: center;
        padding: 10px 0;
        border-bottom: 1px solid #f5f5f5;
      }

      .favorites-dropdown__item:last-child {
        border-bottom: none;
      }

      .favorites-dropdown__item-image {
        width: 60px;
        height: 60px;
        margin-right: 15px;
        flex-shrink: 0;
      }

      .favorites-dropdown__item-image img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .favorites-dropdown__item-info {
        flex: 1;
      }

      .favorites-dropdown__item-title {
        margin: 0 0 5px;
        font-size: 14px;
        font-weight: 500;
        line-height: 1.3;
      }

      .favorites-dropdown__item-price {
        margin: 0;
        font-size: 13px;
        color: #e30613;
        font-weight: 600;
      }

      .favorites-dropdown__item-link {
        margin-left: 10px;
        color: #333;
        text-decoration: none;
        font-size: 13px;
      }

      .favorites-dropdown__footer {
        padding: 15px;
        border-top: 1px solid #eee;
        text-align: center;
      }

      .favorites-dropdown__view-all {
        display: inline-block;
        color: #e30613;
        text-decoration: none;
        font-size: 14px;
        font-weight: 500;
      }

      .favorites-dropdown__count {
        text-align: center;
        padding: 10px 0;
        font-size: 13px;
        color: #666;
      }

      /* Mobile specific styles */
      .favorites-dropdown--mobile {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 90%;
        max-width: 320px;
        border-radius: 8px;
        z-index: 1001;
      }

      @media (max-width: 767px) {
        .favorites-dropdown--mobile {
          width: 90%;
        }
      }
    `;
    document.head.appendChild(styleElement);
  }

  function setupEventListeners() {
    // Desktop wishlist click
    const desktopWishlistLink = document.querySelector('.header-action--wishlist .header-action__link');
    const desktopDropdown = document.querySelector('.header-action--wishlist .favorites-dropdown');

    if (desktopWishlistLink && desktopDropdown) {
      desktopWishlistLink.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        desktopDropdown.classList.toggle('active');
      });
    }

    // Mobile wishlist click
    const mobileWishlistLink = document.querySelector('.mobile-menu__quick-action[href="/pages/favorites"]');
    const mobileDropdown = document.querySelector('.favorites-dropdown--mobile');

    if (mobileWishlistLink && mobileDropdown) {
      mobileWishlistLink.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        mobileDropdown.classList.toggle('active');

        // Add overlay when mobile dropdown is active
        if (mobileDropdown.classList.contains('active')) {
          addMobileOverlay();
        } else {
          removeMobileOverlay();
        }
      });
    }

    // Close mobile dropdown
    const mobileCloseBtn = document.querySelector('.favorites-dropdown__close');
    if (mobileCloseBtn && mobileDropdown) {
      mobileCloseBtn.addEventListener('click', function() {
        mobileDropdown.classList.remove('active');
        removeMobileOverlay();
      });
    }

    // Close dropdowns when clicking outside
    document.addEventListener('click', function(e) {
      if (desktopDropdown && !desktopDropdown.contains(e.target) && !desktopWishlistLink.contains(e.target)) {
        desktopDropdown.classList.remove('active');
      }

      if (mobileDropdown && !mobileDropdown.contains(e.target) && !mobileWishlistLink.contains(e.target)) {
        mobileDropdown.classList.remove('active');
        removeMobileOverlay();
      }
    });
  }

  function addMobileOverlay() {
    // Create overlay if it doesn't exist
    if (!document.querySelector('.favorites-dropdown-overlay')) {
      const overlay = document.createElement('div');
      overlay.className = 'favorites-dropdown-overlay';
      overlay.style.position = 'fixed';
      overlay.style.top = '0';
      overlay.style.left = '0';
      overlay.style.width = '100%';
      overlay.style.height = '100%';
      overlay.style.backgroundColor = 'rgba(0,0,0,0.5)';
      overlay.style.zIndex = '1000';

      document.body.appendChild(overlay);

      // Close dropdown when clicking overlay
      overlay.addEventListener('click', function() {
        const mobileDropdown = document.querySelector('.favorites-dropdown--mobile');
        if (mobileDropdown) {
          mobileDropdown.classList.remove('active');
        }
        removeMobileOverlay();
      });
    }
  }

  function removeMobileOverlay() {
    const overlay = document.querySelector('.favorites-dropdown-overlay');
    if (overlay) {
      overlay.remove();
    }
  }

  function loadFavorites() {
    // Try to get favorites from different localStorage keys
    let favorites = [];

    // Check for items (original theme implementation)
    const itemsWishlist = JSON.parse(localStorage.getItem('items') || '[]');
    if (itemsWishlist.length > 0) {
      // Convert product handles to product objects
      itemsWishlist.forEach(function(handle) {
        fetchProductByHandle(handle, function(product) {
          if (product) {
            favorites.push({
              id: product.id,
              handle: product.handle,
              title: product.title,
              price: formatMoney(product.price),
              image: product.featured_image,
              url: '/products/' + product.handle
            });

            // Update dropdowns after fetching product
            updateFavoritesDropdown(favorites);
          }
        });
      });
    } else {
      // Check for jdm_wishlist (product-template-4.js implementation)
      const jdmWishlist = JSON.parse(localStorage.getItem('jdm_wishlist') || '[]');
      if (jdmWishlist.length > 0) {
        // Convert product IDs to product objects
        jdmWishlist.forEach(function(id) {
          fetchProductById(id, function(product) {
            if (product) {
              favorites.push({
                id: product.id,
                handle: product.handle,
                title: product.title,
                price: formatMoney(product.price),
                image: product.featured_image,
                url: '/products/' + product.handle
              });

              // Update dropdowns after fetching product
              updateFavoritesDropdown(favorites);
            }
          });
        });
      } else {
        // Check for wishlist (favorites-dropdown.js implementation)
        const wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
        if (wishlist.length > 0) {
          favorites = wishlist;
          updateFavoritesDropdown(favorites);
        } else {
          // No favorites found in any storage
          updateFavoritesDropdown([]);
        }
      }
    }
  }

  function fetchProductByHandle(handle, callback) {
    fetch('/products/' + handle + '.js')
      .then(response => response.json())
      .then(product => {
        callback(product);
      })
      .catch(error => {
        console.error('Error fetching product:', error);
        callback(null);
      });
  }

  function fetchProductById(id, callback) {
    // Since Shopify doesn't have a direct endpoint to fetch by ID,
    // we'll need to use the handle approach or a custom endpoint
    // For now, we'll just return null
    callback(null);
  }

  function formatMoney(cents) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    const value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = '${{amount}}';

    function defaultTo(value, defaultValue) {
      return value == null || value !== value ? defaultValue : value;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      const parts = number.split('.');
      const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    return '$' + formatWithDelimiters(cents, 2);
  }

  function updateFavoritesDropdown(favorites) {
    const dropdowns = document.querySelectorAll('.favorites-dropdown');

    dropdowns.forEach(function(dropdown) {
      const emptyMessage = dropdown.querySelector('.favorites-dropdown__empty');
      const itemsContainer = dropdown.querySelector('.favorites-dropdown__items');

      // Clear previous items
      itemsContainer.innerHTML = '';

      if (!favorites || favorites.length === 0) {
        // Show empty message
        emptyMessage.style.display = 'block';
        return;
      }

      // Hide empty message
      emptyMessage.style.display = 'none';

      // Add favorites to dropdown (max 3 items)
      const maxItems = 3;
      const itemsToShow = favorites.slice(0, maxItems);

      itemsToShow.forEach(function(favorite) {
        const itemHTML = `
          <div class="favorites-dropdown__item">
            <div class="favorites-dropdown__item-image">
              <img src="${favorite.image || '/assets/no-image.jpg'}" alt="${favorite.title}">
            </div>
            <div class="favorites-dropdown__item-info">
              <h4 class="favorites-dropdown__item-title">${favorite.title}</h4>
              <p class="favorites-dropdown__item-price">${favorite.price || ''}</p>
            </div>
            <a href="${favorite.url}" class="favorites-dropdown__item-link">View</a>
          </div>
        `;
        itemsContainer.insertAdjacentHTML('beforeend', itemHTML);
      });

      // Add count indicator if there are more items
      if (favorites.length > maxItems) {
        const countHTML = `
          <div class="favorites-dropdown__count">
            +${favorites.length - maxItems} more items
          </div>
        `;
        itemsContainer.insertAdjacentHTML('beforeend', countHTML);
      }
    });
  }
})();
